<script setup lang="ts">
  import { getSerpNoticeLeadBannerContext, LeadBannerTriggerReason } from '@/entities/analytics';
  import { LeadBanner, checkLeadSession } from '@/features/leadBanner';
  import { SERP_SHORT_LEAD_BANNER_TEXTS } from '../config/texts';

  const isLeadBannerVisible = !checkLeadSession();

  const tracking = getSerpNoticeLeadBannerContext(LeadBannerTriggerReason.ShortSerp);
</script>

<template>
  <div
    v-if="isLeadBannerVisible"
    class="serp-short-lead-banner"
  >
    <LeadBanner
      :title="SERP_SHORT_LEAD_BANNER_TEXTS.title"
      :subtitle="SERP_SHORT_LEAD_BANNER_TEXTS.subtitle"
      :button-text="SERP_SHORT_LEAD_BANNER_TEXTS.button"
      :mobile="true"
      :tracking="tracking"
      data-testid="serp-short-lead-banner"
    />
  </div>
</template>

<style scoped lang="scss">
  .serp-short-lead-banner {
    box-sizing: border-box;
    padding: 0 var(--spacing-xs) var(--spacing-xs);
    width: 100%;
  }
</style>
